import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge", "item"]
  static values  = { readUrl: String }

  open() {
    const ids = this.itemTargets
      .filter(el => el.classList.contains("unread"))
      .map(el => el.dataset.id)
    if (!ids.length) return

    fetch(this.readUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      },
      body: JSON.stringify({ ids })
    }).then(r => {
      if (!r.ok) return
      this.itemTargets.forEach(el => el.classList.remove("unread"))
      if (this.hasBadgeTarget) this.badgeTarget.remove()
    })
  }

  delete(event) {
    event.preventDefault()
    const link = event.currentTarget
    const item = link.closest("[data-notifications-target='item']")
    fetch(link.href, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    }).then(r => { if (r.ok && item) item.remove() })
  }
}
